import Reporting from "./reporting";

export default Reporting;
